import React, { useEffect, useState } from 'react'
import { Modal, Button, Divider, Row, Col } from 'antd'
import TableGrid from '../../../shared/TableGrid/TableGrid'
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons'
import './defineWacModal.scss'
import CopyToExcel from '../../../shared/copyToExcel/CopyToExcel'
import { useGlobalNotification } from '../../../utils/notificationProvider'

const AlignmentTypeModal = ({ isVisible, handleCancel, columnData, transformedData }) => {
  const pushNotification = useGlobalNotification()
  const [sorterMrket, setSorterMarket] = useState(null)
  const [copyData, setCopyData] = useState(transformedData)

  useEffect(() => {
    setCopyData(transformedData.sort((a, b) => a?.market.localeCompare(b?.market)))
  }, [transformedData])

  const handleCopySuccess = () => {
    pushNotification(
      'success',
      'Data copied successfully!',
      'Alignment Template data copied successfully.',
      3
    )
  }

  const handleCopyError = () => {
    pushNotification('error', 'Copy failed!', 'Error copying the data.', 3)
  }

  const copyAllColumnsDataToClipboard = () => {
    // console.log("column : ",columnData, transformedData)

    let newSorted_data = copyData

    try {
      const headers = columnData
        .map((col) => (typeof col.title === 'string' ? col.title : col.title.props.children))
        .join('\t')

      const rows = newSorted_data.map((record) =>
        columnData.map((col) => record[col.dataIndex]).join('\t')
      )

      const dataString = [headers, ...rows].join('\n')

      navigator.clipboard
        .writeText(dataString)
        .then(() => {
          handleCopySuccess()
        })
        .catch((err) => {
          console.error('Failed to copy data: ', err)
          handleCopyError()
        })
    } catch (error) {
      console.error('Error while copying data:', error)
      handleCopyError()
    }
  }

  return (
    <Modal
      title="Alignment Type - Default Template"
      visible={isVisible}
      onCancel={handleCancel}
      footer={<></>}
      style={{ minWidth: '1200px', maxHeight: '90vh' }}
      centered
      className="custom-modal"
    >
      <>
        <div className="modal-content-wrapper">
          <div className="define-wac-modal-Header">
            <Row>
              <Col>
                <Button
                  className="button-icon"
                  style={{ marginRight: '8px' }}
                  onClick={copyAllColumnsDataToClipboard}
                >
                  <CopyOutlined />
                </Button>
              </Col>
            </Row>
          </div>
          <div className="alignment-template-Modal-Table" style={{ padding: '16px' }}>
            <TableGrid
              columnsConfig={columnData}
              dataSource={transformedData}
              scroll1={{ y: 240, x: 'max-content' }}
              pagination={false}
              onChange={(pagination, filters, sorter, extra) => {
                // console.log("sorter: ", sorter)
                // setFilterWac(filters);
                setCopyData(extra.currentDataSource)
                setSorterMarket(sorter)
              }}
            />
          </div>
        </div>
      </>
    </Modal>
  )
}

export default AlignmentTypeModal
